import produce from 'immer';
import {
  GET_STORE_ORDERS_START,
  GET_STORE_ORDERS_SUCCESS,
  GET_STORE_ORDERS_FAILED,
  RESEND_ORDER_EMAIL_START,
  RESEND_ORDER_EMAIL_SUCCESS,
  RESEND_ORDER_EMAIL_FAILED,
  UPDATE_STORE_ORDER_START,
  UPDATE_STORE_ORDER_SUCCESS,
  UPDATE_STORE_ORDER_FAILED,
  SAVE_STORE_ORDER_COMMENT_START,
  SAVE_STORE_ORDER_COMMENT_SUCCESS,
  SAVE_STORE_ORDER_COMMENT_FAILED,
  HOLD_ORDERS_START,
  HOLD_ORDERS_SUCCESS,
  HOLD_ORDERS_FAILED,
  UNHOLD_ORDERS_START,
  UNHOLD_ORDERS_SUCCESS,
  UNHOLD_ORDERS_FAILED,
  UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_START,
  UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS,
  UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED,
  GENERATE_ORDERS_INVOICE_PDF_START,
  GENERATE_ORDERS_INVOICE_PDF_SUCCESS,
  GENERATE_ORDERS_INVOICE_PDF_FAILED,
  GET_STORE_ORDER_ITEMS_DETAILS_START,
  GET_STORE_ORDER_ITEMS_DETAILS_SUCCESS,
  GET_STORE_ORDER_ITEMS_DETAILS_FAILED,
  GET_INVOICE_ORDER_DATA_START,
  GET_INVOICE_ORDER_DATA_SUCCESS,
  GET_INVOICE_ORDER_DATA_FAILED,
  GET_ORDER_PRODUCTS_BY_SKUS_START,
  GET_ORDER_PRODUCTS_BY_SKUS_SUCCESS,
  GET_ORDER_PRODUCTS_BY_SKUS_FAILED,
  REFUND_ORDER_START,
  REFUND_ORDER_SUCCESS,
  REFUND_ORDER_FAILED,
  SHIP_ORDER_START,
  SHIP_ORDER_SUCCESS,
  SHIP_ORDER_FAILED,
  GET_NEXTECH_DUPLICATED_CUSTOMERS_START,
  GET_NEXTECH_DUPLICATED_CUSTOMERS_SUCCESS,
  GET_NEXTECH_DUPLICATED_CUSTOMERS_FAILED,
  GET_MODMED_DUPLICATED_CUSTOMERS_START,
  GET_MODMED_DUPLICATED_CUSTOMERS_SUCCESS,
  GET_MODMED_DUPLICATED_CUSTOMERS_FAILED,
  UPDATE_NEXTECH_STATUS_START,
  UPDATE_NEXTECH_STATUS_SUCCESS,
  UPDATE_NEXTECH_STATUS_FAILED,
  GET_INVOICE_COMMENTS_START,
  GET_INVOICE_COMMENTS_SUCCESS,
  GET_INVOICE_COMMENTS_FAILED,
  GET_SHIPPING_COMMENTS_START,
  GET_SHIPPING_COMMENTS_SUCCESS,
  GET_SHIPPING_COMMENTS_FAILED,
  GET_CREDIT_MEMO_COMMENTS_START,
  GET_CREDIT_MEMO_COMMENTS_SUCCESS,
  GET_CREDIT_MEMO_COMMENTS_FAILED,
  GET_ORDERS_SHIPMENTS_START,
  GET_ORDERS_SHIPMENTS_SUCCESS,
  GET_ORDERS_SHIPMENTS_FAILED,
  GET_PEYMENT_METHOD_NAME_START,
  GET_PEYMENT_METHOD_NAME_SUCCESS,
  GET_PEYMENT_METHOD_NAME_FAILED,
} from '../actions/store_orders';


const initialState = {
  storeOrders: [],
  nextechDuplicatedCustomersList: [],
  modmedDuplicatedCustomersList: [],
  invoiceCommentsData: [],
  shippingCommentsData: [],
  creditMemoCommentsData: [],
  ordersTotalCount: 0,
  orderItemsDetails: {},
  orderShipments: {},
  invoiceOrderData: {},
  orderProductsDetails: [],
  paymentMethods: {},
  loadingOrders: false,
  sendingOrderEmail: false,
  updatingStoreOrder: false,
  savingStoreOrderComment: false,
  isChangingHoldOrdersStatus: false,
  isChangingPostedOrdersStatus: false,
  loadingStoreOrderInvoicePdf: false,
  loadingStoreOrderItemsDetails: false,
  loadingNextechDuplicatedCustomers: false,
  loadingModmedDuplicatedCustomers: false,
  loadingUpdateNextechStatus: false,
  loadingInvoiceComments: false,
  loadingShippingComments: false,
  loadingCreditMemoComments: false,
  loadingOrderShipments: false,
  refundingOffline: false,
  loadingInvoiceOrderData: false,
  loadingOrderProductsDetails: false,
  loadingOrderRefund: false,
  shipOrderLoading: false,
  loadingPaymentMethodName: false,
};


const formReducer = produce((state: IStoreOrdersState = initialState, action) => {
  switch (action.type) {
    case GET_STORE_ORDERS_START: {
      state.loadingOrders = true;
      break;
    }

    case GET_STORE_ORDERS_SUCCESS: {
      const {items, total_count} = action.data;
      state.storeOrders = items;
      state.ordersTotalCount = total_count;
      state.loadingOrders = false;
      break;
    }

    case GET_STORE_ORDERS_FAILED: {
      state.loadingOrders = false;
      break;
    }

    case RESEND_ORDER_EMAIL_START: {
      state.sendingOrderEmail = true;
      break;
    }

    case RESEND_ORDER_EMAIL_SUCCESS: {
      state.sendingOrderEmail = false;
      break;
    }

    case RESEND_ORDER_EMAIL_FAILED: {
      state.sendingOrderEmail = false;
      break;
    }

    case UPDATE_STORE_ORDER_START: {
      state.updatingStoreOrder = true;
      break;
    }

    case UPDATE_STORE_ORDER_SUCCESS: {
      const {delivery_status = '0'} = action.data.extension_attributes;

      state.storeOrders = state.storeOrders.map((order) => {
        if (order.entity_id === action.data.entity_id) {
          return {
            ...order,
            extension_attributes: {
              ...order.extension_attributes,
              delivery_status
            }
          };
        }

        return order;
      });

      state.updatingStoreOrder = false;
      break;
    }

    case UPDATE_STORE_ORDER_FAILED: {
      state.updatingStoreOrder = false;
      break;
    }

    case SAVE_STORE_ORDER_COMMENT_START: {
      state.savingStoreOrderComment = true;
      break;
    }

    case SAVE_STORE_ORDER_COMMENT_SUCCESS: {
      const {orderId, comment} = action;

      state.storeOrders = state.storeOrders
        .map((order) => order.entity_id === orderId
          ? {...order, status_histories: [comment, ...order.status_histories]}
          : order
        );
      state.savingStoreOrderComment = false;
      break;
    }

    case SAVE_STORE_ORDER_COMMENT_FAILED: {
      state.savingStoreOrderComment = false;
      break;
    }

    case HOLD_ORDERS_START: {
      state.isChangingHoldOrdersStatus = true;
      break;
    }

    case HOLD_ORDERS_SUCCESS: {
      const {orderIds} = action;

      state.storeOrders = state.storeOrders.map((order) => {
        if (orderIds.includes(order.entity_id)) {
          return {
            ...order,
            hold_before_status: order.status,
            hold_before_state: order.state,
            status: 'holded',
            state: 'holded'
          };
        }

        return order;
      });
      state.isChangingHoldOrdersStatus = false;
      break;
    }

    case HOLD_ORDERS_FAILED: {
      state.isChangingHoldOrdersStatus = false;
      break;
    }


    case UNHOLD_ORDERS_START: {
      state.isChangingHoldOrdersStatus = true;
      break;
    }

    case UNHOLD_ORDERS_SUCCESS: {
      const {orderIds} = action;

      state.storeOrders = state.storeOrders.map((order) => {
        if (orderIds.includes(order.entity_id)) {
          return {
            ...order,
            status: order.hold_before_status,
            state: order.hold_before_state,
          };
        }

        return order;
      });
      state.isChangingHoldOrdersStatus = false;
      break;
    }

    case UNHOLD_ORDERS_FAILED: {
      state.isChangingHoldOrdersStatus = false;
      break;
    }

    case UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_START: {
      state.isChangingPostedOrdersStatus = true;
      break;
    }

    case UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_SUCCESS: {
      const {orders} = action;

      state.storeOrders = state.storeOrders.map((order) => {
        const updatedOrder = orders.find((o) => o.entity_id === order.entity_id);

        if (updatedOrder) {
          return {
            ...order,
            extension_attributes: {
              ...order.extension_attributes,
              delivery_status: updatedOrder.extension_attributes.delivery_status
            }
          };
        }

        return order;
      });

      state.isChangingPostedOrdersStatus = false;
      break;
    }

    case UPDATE_MULTIPLE_ORDERS_POSTED_STATUS_FAILED: {
      state.isChangingPostedOrdersStatus = false;
      break;
    }

    case GENERATE_ORDERS_INVOICE_PDF_START: {
      state.loadingStoreOrderInvoicePdf = true;
      break;
    }

    case GENERATE_ORDERS_INVOICE_PDF_SUCCESS: {
      state.loadingStoreOrderInvoicePdf = false;
      break;
    }

    case GENERATE_ORDERS_INVOICE_PDF_FAILED: {
      state.loadingStoreOrderInvoicePdf = false;
      break;
    }

    case GET_STORE_ORDER_ITEMS_DETAILS_START: {
      state.loadingStoreOrderItemsDetails = true;
      break;
    }

    case GET_STORE_ORDER_ITEMS_DETAILS_SUCCESS: {
      const {data, entity_id} = action;
      state.orderItemsDetails[entity_id] = data;
      state.loadingStoreOrderItemsDetails = false;
      break;
    }

    case GET_STORE_ORDER_ITEMS_DETAILS_FAILED: {
      state.loadingStoreOrderItemsDetails = false;
      break;
    }

    case GET_INVOICE_ORDER_DATA_START: {
      state.loadingInvoiceOrderData = true;
      break;
    }

    case GET_INVOICE_ORDER_DATA_SUCCESS: {
      const {data} = action;
      state.invoiceOrderData = data.items.length ? data.items[0] : {};
      state.loadingInvoiceOrderData = false;
      break;
    }

    case GET_INVOICE_ORDER_DATA_FAILED: {
      state.loadingInvoiceOrderData = false;
      break;
    }

    case GET_ORDER_PRODUCTS_BY_SKUS_START: {
      state.orderProductsDetails = true;
      break;
    }

    case GET_ORDER_PRODUCTS_BY_SKUS_SUCCESS: {
      const {data} = action;
      state.orderProductsDetails = data.catalogProducts;
      state.loadingOrderProductsDetails = false;
      break;
    }

    case GET_ORDER_PRODUCTS_BY_SKUS_FAILED: {
      state.loadingOrderProductsDetails = false;
      break;
    }

    case REFUND_ORDER_START: {
      state.loadingOrderRefund = true;
      break;
    }

    case REFUND_ORDER_SUCCESS: {
      state.loadingOrderRefund = false;
      break;
    }

    case REFUND_ORDER_FAILED: {
      state.loadingOrderRefund = false;
      break;
    }

    case SHIP_ORDER_START: {
      state.shipOrderLoading = true;
      break;
    }

    case SHIP_ORDER_SUCCESS: {
      const { entityId, isOrderComplete, shipData } = action;

      const updatedOrder = state.storeOrders.find((order) => order.entity_id === entityId);
      const shippedIds = shipData.items.map((shipItem) => shipItem.order_item_id);
      const trackItem = shipData.tracks?.[0];

      const updatedOrderQtyShipped = updatedOrder.items.map((item) => {
        if (shippedIds.includes(item.item_id)) {
          const {qty} = shipData.items.find((shippedItem) => shippedItem.order_item_id === item.item_id);

          return {...item, qty_shipped: item.qty_shipped + qty};
        }

        return item;
      });

      state.storeOrders =  state.storeOrders.map((order) => {
        if (order.entity_id === entityId) {
          const updatedAttributes = {...order.extension_attributes, shipment_tracks: [...order.extension_attributes.shipment_tracks, trackItem]};
          return {...order, items: updatedOrderQtyShipped, extension_attributes: updatedAttributes};
        }

        return order;
      });

      if (isOrderComplete) {
        state.storeOrders = state.storeOrders
          .map((order) => order.entity_id === entityId
            ? {...order, status: 'complete'}
            : order
          );
      }

      state.shipOrderLoading = false;
      break;
    }

    case SHIP_ORDER_FAILED: {
      state.shipOrderLoading = false;
      break;
    }

    case GET_NEXTECH_DUPLICATED_CUSTOMERS_START: {
      state.loadingNextechDuplicatedCustomers = true;
      break;
    }

    case GET_NEXTECH_DUPLICATED_CUSTOMERS_SUCCESS: {
      const { data } = action;
      state.nextechDuplicatedCustomersList = data;
      state.loadingNextechDuplicatedCustomers = false;
      break;
    }

    case GET_NEXTECH_DUPLICATED_CUSTOMERS_FAILED: {
      state.loadingNextechDuplicatedCustomers = false;
      break;
    }

    case GET_MODMED_DUPLICATED_CUSTOMERS_START: {
      state.loadingModmedDuplicatedCustomers = true;
      break;
    }

    case GET_MODMED_DUPLICATED_CUSTOMERS_SUCCESS: {
      const { data } = action;
      state.modmedDuplicatedCustomersList = data;
      state.loadingModmedDuplicatedCustomers = false;
      break;
    }

    case GET_MODMED_DUPLICATED_CUSTOMERS_FAILED: {
      state.loadingModmedDuplicatedCustomers = false;
      break;
    }

    case UPDATE_NEXTECH_STATUS_START: {
      state.loadingUpdateNextechStatus = true;
      break;
    }

    case UPDATE_NEXTECH_STATUS_SUCCESS: {
      const { id } = action.data.customer;

      state.storeOrders = state.storeOrders.map((order) => {
        if (id == order.customer_id && order.extension_attributes.emr_sync_error == 'duplicated_customer') {
          const updatedExtensionAttributes = {...order.extension_attributes, emr_sync_error: undefined};
          return {...order, extension_attributes: updatedExtensionAttributes};
        }

        return order;
      });

      state.loadingUpdateNextechStatus = false;
      break;
    }

    case UPDATE_NEXTECH_STATUS_FAILED: {
      state.loadingUpdateNextechStatus = false;
      break;
    }

    case GET_INVOICE_COMMENTS_START: {
      state.loadingInvoiceComments = true;
      break;
    }

    case GET_INVOICE_COMMENTS_SUCCESS: {
      const { items } = action.data;

      state.invoiceCommentsData = items;

      state.loadingInvoiceComments = false;
      break;
    }

    case GET_INVOICE_COMMENTS_FAILED: {
      state.loadingInvoiceComments = false;
      break;
    }

    case GET_SHIPPING_COMMENTS_START: {
      state.loadingShippingComments = true;
      break;
    }

    case GET_SHIPPING_COMMENTS_SUCCESS: {
      const { items } = action.data;

      state.shippingCommentsData = items;

      state.loadingShippingComments = false;
      break;
    }

    case GET_SHIPPING_COMMENTS_FAILED: {
      state.loadingShippingComments = false;
      break;
    }

    case GET_CREDIT_MEMO_COMMENTS_START: {
      state.loadingCreditMemoComments = true;
      break;
    }

    case GET_CREDIT_MEMO_COMMENTS_SUCCESS: {
      const { items } = action.data;

      state.creditMemoCommentsData = items;

      state.loadingCreditMemoComments = false;
      break;
    }

    case GET_CREDIT_MEMO_COMMENTS_FAILED: {
      state.loadingCreditMemoComments = false;
      break;
    }

    case GET_ORDERS_SHIPMENTS_START: {
      state.loadingOrderShipments = true;
      break;
    }

    case GET_ORDERS_SHIPMENTS_SUCCESS: {
      const { items } = action.data.shipments;
      const { orderId } = action;

      state.orderShipments = {...state.orderShipments, [orderId]: items};
      state.loadingOrderShipments = false;
      break;
    }

    case GET_ORDERS_SHIPMENTS_FAILED: {
      state.loadingOrderShipments = false;
      break;
    }

    case GET_PEYMENT_METHOD_NAME_START: {
      state.loadingPaymentMethodName = true;
      break;
    }

    case GET_PEYMENT_METHOD_NAME_SUCCESS: {
      const { method, name } = action.data;
      state.paymentMethods[method] = name;
      state.loadingPaymentMethodName = false;
      break;
    }

    case GET_PEYMENT_METHOD_NAME_FAILED: {
      state.loadingPaymentMethodName = false;
      break;
    }

    default:
      break;
  }
}, initialState);

export default formReducer;
